import { authorize, putRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function stopPairingStatusAPI(userId) {
  const url = `${AWS_API_URL}/2n/users/${userId}/mobile-key/stop-pairing`;

  return putRequest(url, {}, await authorize());
}
